import { queryClient } from '@/queryClient'
import { leaderboardQueryKeys } from '@/constants/leaderboardQueryKeys'

export function invalidateLeaderboardQueries() {
  queryClient.invalidateQueries({ queryKey: leaderboardQueryKeys.all })
}
